<button class="install-button"  (click)="install()" >Zainstaluj aplikację</button>

<pwa-install  styles='{"--tint-color": "#015C2BFF"}' description="Aplikacja PWA ZGranego Grona"  use-local-storage="1" icon="icons/icon-72x72.png" #pwaInstall [name]="name" (pwa-install-how-to-event)="eventHandle($event)"></pwa-install>

